
const types = {
    SET_BAR_IMAGE: 'SET_BAR_IMAGE',
    SET_DRAWER: 'SET_DRAWER',
};


export const state = {
    barColor: 'rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)',
    barImage: 'https://demos.creative-tim.com/material-dashboard/assets/img/sidebar-1.jpg',
    showDrawer: true,
}

export const mutations = {
    [types.SET_BAR_IMAGE] (state: any, payload: any) {
        state.barImage = payload
    },
    [types.SET_DRAWER] (state: any, payload: any) {
        state.showDrawer = payload
    },
}


export const actions = {
    setDrawer({ commit }:any, payload: any) {
        commit(types.SET_DRAWER, payload);
    }
}